<template>
  <div class="black-container">
    <div class="container" id="titleLogo">
      <div class="flex-logo">
        <div class="logo" @click="indexHome">
          <!-- 侧边导航 -->
          <div @mouseleave="hideDetail()" class="move-class">
            <div class="nav-side" ref="navSide">
              <ul>
                <li v-for="item in categoryList" :key="item.area_id" class="sort-list" @mouseenter="showDetail(item)">
                  <div class="flex">
                    <div class="img " :class="defaultCategryIcons[item.show_name]"></div>
                    <p class="font14" @click.stop="onClassifyClick(null, item.area_id, item.show_name)">
                      {{ item.show_name }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <transition name="fade">
              <div v-show="panelData && panelData.length > 0" class="detail-item-panel panel-1"
                :duration="{ enter: 100, leave: 100 }" ref="itemPanel1">
                <div class="item-thumb ">
                  <div v-for="panel in panelData" :key="panel.cat_id">
                    <div>
                      <div class="one-classify">{{ panel.name }}</div>
                      <div class="classList">
                        <div class="flex" v-for="panelChild in panel.child" :key="panelChild.cat_id">
                          <ul>
                            <li class="detail-item-row">
                              <p class="detail-item-title">
                                {{ panelChild.name }}
                              </p>
                              <div class="three-classify">
                                <!--
                                    to="/goodsList"
                                   -->
                                <a href="#" v-for="item in panelChild.child" :key="item.cat_id">
                                  <span class="detail-item" @click.stop="onClassifyClick(item.cat_id, null, item.name)">{{
                                    item.name
                                  }}</span>
                                </a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <!--<div class="title">
          <ul class="title-nav">
            <li v-for="(items, index) in nav"
                :key="index"
                :class="{ active: curPath === items.path }">
              <a href="#"
                 @click="toSecPath(items)">{{ items.name }}</a>
              &lt;!&ndash; <router-link :to="items.path">{{ items.name }}</router-link> &ndash;&gt;
            </li>
          </ul>
        </div>-->
        <div class="search-main">
          <div class="input-box">
            <Input class="search-input" search enter-button="搜索" placeholder="输入商品/厂家汉字或拼音首字母" v-model="searchData"
              @on-search="searchKeyWord" @on-change="changeKeyWord" @on-blur="listNone" />
            <Icon type="ios-search-outline icon-style" size="22" />

            <!-- <Icon type="ios-search-outline search-icon" size="24" /> -->
          </div>
          <div class="hotSearch">
            热门搜索：
            <span v-for="(ites, index) in hotWordsList.search_new" :key="index" @click="goHotWords(ites.name)">{{
              ites.name }}</span>
          </div>
          <div class="searchList" v-show="searchContent">
            <div class="search-goodList">
              <ul>
                <li class="title">
                  <span></span>
                  产品
                </li>
                <li class="item" @click="toList(item, '1')" v-for="(item, index) in searchList.goods" :key="index">
                  <p><span></span> {{ item }}</p>
                  <span class="firstManufacturer"></span>
                </li>
              </ul>
            </div>
            <div class="manufactor-goodList">
              <ul>
                <li class="title">
                  <span></span>
                  厂家
                </li>
                <li class="item" @click="toList(item, '2')" v-for="(item, index) in searchList.manufacturer" :key="index">
                  <p><span></span> {{ item }}</p>
                  <span class="firstManufacturer"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="logo-phoneNumber"><img src="/static/img/index/img/img-1.png" alt=""></div>
        <div class="logo-code">
          <Poptip trigger="hover" placement="right" width="170">
            <div><img src="/static/img/index/img/img-2.png" style="width: 60px;height:60px;" alt="">
              <p>公众号</p>
            </div>
            <div class="hover-img" slot="content">
              <img src="/static/img/index/img/img_12.png" style="width: 90px;height:90px;" alt="">
              <p class="code-title">官方微信</p>
              <p class="code-txt">扫描二维码 关注我们</p>
            </div>
          </Poptip>
          <Poptip trigger="hover" placement="right" width="450">
            <div>
              <img src="/static/img/index/img/app-download.jpg" style="width: 60px;height:60px;" alt="">
              <p>app下载</p>
            </div>
            <div class="hover-img" slot="content">
              <img src="/static/img/index/img/1699334572609.jpg" alt="">
              <p class="code-txt">扫描二维码 立即下载</p>
            </div>
          </Poptip>
          <div>

          </div>
        </div>
        <!--<i-input v-model="sreachData" size="large" class="sreach" placeholder="输入你想查找的商品">
          <Button slot="append" icon="ios-search" @click="sreach"></Button>
        </i-input>-->
        <!--<Tag v-for="(item, index) in promotionTags" :key="index" closable  @on-close="closeTags(index)"><span @click="selectTags(index)">{{item}}</span></Tag>-->
      </div>
      <div class="menu-title" v-if="rank_id != 8">
        <ul class="title-nav">
          <li v-for="(items, index) in nav" :key="index" :class="{ active: curPath == items.pc_url.split('?')[0] }">
            <a href="javascript:;" style="display: flex;align-items: center;" @click="toSecPath(items)">{{ items.name }}
              <span class="nav-tips">
                <img src="/static/img/index/new.png" v-if="items.subscript == 1" alt="" style="width:25px;height: 25px;">
                <img src="https://static.csycj.com/icon/hot.png" v-if="items.subscript == 2" alt=""
                  style="width:25px;height: 25px;">
              </span>
            </a>
            <!-- <router-link :to="items.path">{{ items.name }}</router-link> -->
          </li>
        </ul>
      </div>
    </div>

    <!--吸顶-->

    <div class="flex-container" id="flex-container">
      <div class="isFixed">
        <div class="container">
          <div class="flex-logo">
            <div class="logo" @click="indexHome"></div>
            <div class="search-main">
              <div class="input-box">
                <Input class="search-input" search enter-button="搜索" placeholder="输入商品/厂家汉字或拼音首字母" v-model="searchData"
                  @on-search="searchKeyWord" @on-change="changeKeyWord" @on-blur="listNone" />
                <Icon type="ios-search-outline icon-style" size="22" />
              </div>
              <div class="hotSearch">
                热门搜索：
                <span v-for="(ites, index) in hotWordsList.search_new" :key="index" @click="goHotWords(ites.name)">{{
                  ites.name }}</span>
              </div>
              <div class="searchList" v-show="searchContent">
                <div class="search-goodList">
                  <ul>
                    <li class="title">
                      <span></span>
                      产品
                    </li>
                    <li class="item" @click="toList(item, '1')" v-for="(item, index) in searchList.goods" :key="index">
                      <p><span></span> {{ item }}</p>
                      <span class="firstManufacturer"></span>
                    </li>
                  </ul>
                </div>
                <div class="manufactor-goodList">
                  <ul>
                    <li class="title">
                      <span></span>
                      厂家
                    </li>
                    <li class="item" @click="toList(item, '2')" v-for="(item, index) in searchList.manufacturer"
                      :key="index">
                      <p><span></span> {{ item }}</p>
                      <span class="firstManufacturer"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="logo-phoneNumber"><img src="/static/img/index/img/img-1.png" alt=""></div>
            <div class="logo-code">
              <Poptip trigger="hover" placement="bottom" width="170">
                <div style="display:flex;align-items: center;justify-content: center;width: 100%;"><img
                    src="/static/img/index/img/img-2.png" style="width: 60px;height:60px;" alt=""></div>
                <div class="hover-img" slot="content">
                  <img src="/static/img/index/img/img_12.png" style="width: 90px;height:90px;" alt="">
                  <p class="code-title">官方微信</p>
                  <p class="code-txt">扫描二维码 关注我们</p>
                </div>
              </Poptip>
              <div>

              </div>
            </div>
            <!--<i-input v-model="sreachData" size="large" class="sreach" placeholder="输入你想查找的商品">
              <Button slot="append" icon="ios-search" @click="sreach"></Button>
            </i-input>-->
            <!--<Tag v-for="(item, index) in promotionTags" :key="index" closable  @on-close="closeTags(index)"><span @click="selectTags(index)">{{item}}</span></Tag>-->
          </div>
          <div v-if="rank_id != 8" class="menu-title">
            <ul class="title-nav">
              <li v-for="(items, index) in nav" :key="index" :class="{ active: curPath == items.pc_url.split('?')[0] }">
                <a href="javascript:;" style="display: flex;align-items: center" @click="toSecPath(items)">{{ items.name }}
                  <span class="nav-tips">
                    <img src="/static/img/index/new.png" v-if="items.subscript == 1" alt=""
                      style="width:25px;height: 25px;">
                    <img src="https://static.csycj.com/icon/hot.png" v-if="items.subscript == 2" alt=""
                      style="width:25px;height: 25px;">
                  </span>
                </a>
                <!-- <router-link :to="items.path">{{ items.name }}</router-link> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--吸顶-->
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState, mapGetters, mapMutations } from "vuex";
import { getNavBar } from "@/api/commonApi";
import { defaultCategryIcons } from "./nav/categoryIcons";
import { getCategory, getGoodsSearch } from "@/api/goods";
import { getRightNumAndHotWords } from "@/api/commonApi";
import { isEmpty } from "@/utils";
import { homeNavBarRoute } from "./nav/staticData";
import { lineLocal } from '@/api/apiPot'
import nav from "@/mixins/nav";

export default {
  name: "Search",
  mixins: [nav],
  data() {
    return {
      nav: [
        { type: "首页", path: "" },
        { type: "普药", path: "/GoodsList" },
        { type: "中药专区", path: "/ChineseMedicineZone" },
        {
          type: "医药器械",
          path: ""
        },
        {
          type: "品牌专区",
          path: ""
        },
        {
          type: "促销专区",
          path: "/Promotion"
        },
        {
          type: "高毛专区",
          path: ""
        },
        {
          type: "积分商城",
          path: "/PointsMall"
        }
      ],
      promotionTags: [
        "买2免1",
        "领200神券",
        "199减100",
        "母婴5折抢",
        "充100送20"
      ],
      panel1: false,
      panel2: false,
      panelData1: {
        classNav: [
          {
            classify: "五官科类用药",
            title: "西药",
            tags: []
          }
        ]
      },
      panelData2: {
        classNav: [
          {
            classify: "皮肤及外用药",
            title: "西药",
            tags: []
          }
        ]
      },
      panelData: [],
      curArea_id: "", //当前选中的大分类
      categoryList: [],
      defaultCategryIcons: defaultCategryIcons,
      homeNavBarRoute,
      searchData: "", //搜索框搜索数据
      searchContent: false, //搜索下拉框默认隐藏
      searchList: [], //搜索下拉列表
      hotWordsList: [], //搜索热词列表
      rank_id: 0
    };
  },
  computed: {
    ...mapState(["marketing"]),
    ...mapGetters(["navData"]),

    curPath() {
      let pathList = this.$route.path.split("/");
      if (pathList.length > 1) {
        return `/${pathList[1]}`;
      } else {
        return "/";
      }
    }
  },
  watch: {
    // 监听导航栏数据变化
    navData: {
      handler(newVal, oldVal) {
        this.nav = this.navData;
      },
      deep: true,
      immediate: true
    }

  },
  mounted() {

     let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
     if(userInfo){
       this.rank_id = userInfo.rank_id
     }
    $(function () {
      //1.内容大于800px scroll--->scrollTop
      $(window).on("scroll", function () {
        var $scroll = $(this).scrollTop();
        if ($scroll >= 700) {
          $("#flex-container").show();
        } else {
          $("#flex-container").hide();
        }

      });

    });
    // this.getNavData();
    this.getGoodsCategory();
    this.hotList();

  },
  methods: {
    ...mapMutations(['new_customer_set']),
    classStyle() {
      /*鼠标移入右侧分类样式改变*/
      $(".nav-side").css({ borderRadius: "10px 0 0 10px" });
    },
    moveClassStyle() {
      /*鼠标移出右侧分类样式恢复*/
      $(".nav-side").css({ borderRadius: "10px" });
    },
    indexHome() {
      this.$router.push("/");
    },
    closeTags(index) {
      this.promotionTags.splice(index, 1);
    },
    selectTags(index) {
      /* this.sreachData = this.promotionTags[index];*/
    },
    searchKeyWord() {
      /**点击获取搜索列表 */
      if (this.searchData == '') {
        this.$message.warning("请输入想要搜索的内容！");
        return
      }
      lineLocal({ source_type: 4, source_info: this.searchData })
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: this.searchData,
            show_id: '' //普药
          }
        }
      });
    },
    /*关键字change更改*/
    changeKeyWord() {
      if (this.searchData == '') {
        this.$message.warning("请输入想要搜索的内容！");
        return
      }
      // 格式化为 "yyyy-MM-dd HH:mm:ss" 格式


      /**搜索框change获取搜索列表 */
      let _this = this;
      if (_this.searchData.trim().length > 0)
        getGoodsSearch({ keywords: _this.searchData })
          .then(res => {
            this.searchList = res.data;
            if (
              this.searchList.goods.length != 0 ||
              this.searchList.manufacturer.length != 0
            ) {
              this.searchContent = true;
            }
          })
          .catch(err => {
          });
      else {
        this.searchContent = false;
      }
    },
    /**搜索按钮点击 */
    searchClick() {
      window.sessionStorage.setItem("searchInput", this.searchData);
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: this.searchData,
            show_id: '' //普药
          }
        }
      });
    },
    toList(item, type) {
      /*带关键字跳转列表*/
      if (item != '') {
        this.searchData = item;
      }
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: item,
            show_id: '',//普药
            type
          }
        }
      });
    },
    goHotWords(name) {
      /*带热门搜索词跳转列表*/
      window.sessionStorage.setItem("searchInput", name);
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: name,
            show_id: '' //普药
          }
        }
      });
    },
    hotList() {
      /**搜索框下方-热门搜索 */
      let _this = this;
      getRightNumAndHotWords()
        .then(res => {
          this.hotWordsList = res.data;
          sessionStorage.setItem('new_customer', res.data.new_customer)
          this.new_customer_set(res.data.new_customer)
        })
        .catch(err => {
        });
    },
    listNone() {
      setTimeout(() => {
        /*搜索框失去焦点时-下拉搜索列表隐藏*/
        this.searchContent = false;
      }, 500);
    },
    showDetail(row) {
      if (!isEmpty(row)) {
        this.curArea_id = row.area_id;
        this.panelData = row.categories;
      }
    },
    hideDetail(level) {
      this.panelData = [];
    },
    /*监听滚动*/
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#searchBar").offsetTop;
      scrollTop > offsetTop
        ? (this.searchBarFixed = true)
        : (this.searchBarFixed = false);
    },
    getNavData() {
      getNavBar({ id: 1 })
        .then(res => {
          if (res.data) {
            res.data.forEach(element => {
              let nav = this.homeNavBarRoute.find(nav => {
                return nav.id === element.id + "";
              });
              element.path = nav ? nav.path : "";
            });
            this.nav = res.data;
            let homeItem = { id: "0", name: "首页", url: "/", path: "/" };
            this.nav.unshift(homeItem);
          }
        })
        .catch(err => {
        });
    },
    getGoodsCategory() {
      getCategory()
        .then(res => {
          this.categoryList = [];
          this.categoryList = res.data;
        })
        .catch(err => {
        });
    },
    onClassifyClick(cat_id, area_id, ddd) {
      lineLocal({ source_type: 6, source_info: ddd })
      this.$store.dispatch("goods/setGoodListFrom", 1);

      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            area_id: area_id || this.curArea_id,
            cat_id: cat_id || "",
            show_id: '' //普药
          }
        }
      });
    }
  },
  updated() {
    /* this.$refs.itemPanel1.style.left =
       this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
     this.$refs.itemPanel2.style.left =
       this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
     this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + 'px';
     this.$refs.itemPanel2.style.top = this.$refs.navSide.offsetTop + 'px';*/
  },
  destroyed() {
    /*销毁滚动监听*/
    window.removeEventListener("scroll", this.handleScroll);
  },
  store
};
</script>
<style lang="less" scoped>
.black-container {
  background-color: #fff;
}

#flex-container {
  width: 100%;
  display: none;
}

.isFixed {
  position: fixed;
  background-color: #fff;
  top: 0;
  z-index: 999;
  width: 100%;
  box-shadow: 0 5px 4px 0 rgb(0 0 0 / 5%);
}

.container {
  width: 1200px;
  margin: 0 auto;
}

/*--------------搜索------------------*/
.search-main {
  position: relative;
  margin-left: 50px;

  .input-box {
    position: relative;
  }

  .search-input {
    width: 500px;
    height: 40px;
    background: #fff;
    border-radius: 15px;
    margin-top: 35px;
    // position: relative;
  }

  .icon-style {
    position: absolute;
    top: 10px;
    color: #fff;
    left: 410px;
    z-index: 9999;
  }

  .search-input /deep/ .ivu-input {
    height: 40px;
    border: 1px solid #629812;
  }

  .search-input /deep/ .ivu-input-search {
    padding: 0 24px 0 44px !important;
    background: #629812 !important;
    border-color: #629812 !important;
    font-size: 16px;
    width: 32px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-shadow: 0px 2px 4px rgba(196, 168, 135, 0.2);
  }

  .search-icon {
    position: absolute;
    top: 8px;
    right: 61px;
    z-index: 3;
    color: #fff;
  }

  .search-input /deep/ .ivu-input:focus {
    border-color: #629812;
    outline: 0;
    box-shadow: 0 0 0 0 rgb(255 255 255 / 0%);
  }

  .search-input /deep/ .ivu-input:hover {
    border-color: #629812;
  }

  input {
    outline: 0;
  }

  .hotSearch {
    margin-top: 6px;
    font-size: 14px;
    max-width: 500px;

    span {
      color: #666;
      margin-right: 12px;
      cursor: pointer;
    }
  }

  .searchList {
    position: absolute;
    top: 75px;
    left: 0;
    z-index: 15;
    width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #fff;
    font-size: 12px;
    color: #666;
    text-indent: 10px;
    border: 1px solid #629812;
    border-top: none;
    padding: 5px 0;

    .search-goodList {}

    .title {
      height: 25px;
      line-height: 25px;
      font-size: 14px;
      font-weight: 700;
      color: #629812;

      span {
        display: inline-block;
        width: 3px;
        height: 14px;
        background-color: #629812;
        margin-right: 4px;
      }
    }

    .item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      cursor: pointer;

      p {
        /* width: 140px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        height: 24px;
        line-height: 24px;

        span {
          color: #629812;
        }
      }

      .firstManufacturer {
        margin-top: 10px;
        /*width: 60px;*/
        height: 16px;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
        color: #666;
        font-size: 14px;
      }
    }

    .item:hover {
      background-color: #f6f6f6;
    }
  }
}

/*--------------搜索------------------*/
.flex-logo {
  width: 100%;
  height: 110px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;

  /* -webkit-box-pack: justify;
     -ms-flex-pack: justify;
     justify-content: space-between;*/
  .logo {
    width: 265px;
    height: 67px;
    background: url(./../../static/img/index/img/home_logo.png) no-repeat;
    cursor: pointer;
    margin-top: 25px;
    position: relative;
  }

  .logo-phoneNumber {
    width: 190px;
    height: 50px;
    margin: 30px 0 0 20px;
  }

  .logo-code {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 28px 0 0 30px;

    .hover-img {
      padding-top: 20px;
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
    }

    p {
      width: 100%;
      line-height: 22px;
      text-align: center;
    }

    .code-title {
      text-align: center;
      font-size: 14px;
      color: #666;
    }

    .code-txt {
      text-align: center;
      font-size: 12px;
      color: #666;
      margin-bottom: 10px;
    }
  }

  .logo-code /deep/ .ivu-poptip-body {
    padding: 0;
  }
}

.menu-title {
  height: 60px;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  // padding: 0 10px;

  .title-nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-around;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    height: 60px;
    align-items: center;
    /*padding-bottom: 10px;
      margin-bottom: -10px;*/
    li {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #252525;
      /*  line-height: 22px;*/
      margin: 20px 0 0 0;
      cursor: pointer;

      a {
        color: #252525;
      }

      a:hover {
        color: #629812;
      }
    }

    .active {
      a {
        color: #629812;
        //padding-bottom: 15px;
        border-radius: 2px;
        border-bottom: 3px solid #629812;
      }
    }
  }

  // .title-nav li:first-child a {
  //   background: #629812;
  //   border-radius: 13px;
  //   color: #fff;
  //   padding: 3px 14px;
  // }
}

.move-class:hover .nav-side {
  border-radius: 10px 0 0 10px;
}

.nav-side {
  width: 220px;
  // height: 410px;
  padding: 0;
  color: #333;
  z-index: 10;
  position: absolute;
  top: 155px;
  left: 0;
  background: #fcfcfe;
  box-shadow: 0px 2px 8px 0px rgba(179, 179, 179, 0.2);
  border-radius: 10px;
}

.nav-side:hover {}

.sort-list {
  .flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .img {
    width: 22px;
    height: 22px;
    margin: 0 8px 0 12px;
  }

  .img0 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -14px -16px;
  }

  .img1 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -48px -16px;
  }

  .img2 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -82px -16px;
  }

  .img3 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -116px -16px;
  }

  .img4 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -150px -16px;
  }

  .img5 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -184px -16px;
  }

  .img6 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -218px -16px;
  }

  .img7 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -252px -16px;
  }

  .img8 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -286px -16px;
  }

  .img9 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -320px -16px;
  }

  .img10 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -14px -51px;
  }

  .img11 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -48px -51px;
  }

  .img12 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -155px -154px;
  }
}

.sort-list:first-child {
  border-radius: 10px 0 0 0;
}

.sort-list:last-child {
  border-radius: 0 0 0 10px;
}

.nav-side ul {
  width: 100%;
  padding: 5px 0;
  list-style: none;
}

.nav-side li {
  height: 34px;
  line-height: 34px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  cursor: pointer;
  font-size: 12px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
  //margin: 15px 0;
}

.nav-side li:hover {
  background: #fff;
}

.nav-side-item:hover {
  cursor: pointer;
  color: #629812;
}

.nav-side .sort-list:hover .detail-item-panel {
  display: block;
}

/*导航内容*/
.nav-content {
  width: 100%;
  /* margin-left: 15px;*/
  /*overflow: hidden;
    float: left;*/
}

.nav-content /deep/ .ivu-carousel-arrow.right {
  right: 360px;
}

.nav-content /deep/ .ivu-carousel-arrow.left {
  left: 620px;
}

.nav-content /deep/ .ivu-carousel-arrow {
  width: 60px;
  height: 60px;
  font-size: 2em;
}

.nav-content /deep/ .ivu-carousel-dots-inside {
  display: block;
  position: absolute;
  bottom: 140px;
  left: -17%;
}

.nav-content /deep/ .ivu-carousel-dots li button {
  background-color: #629812;
}

.nav-content /deep/ .ivu-icon {
  line-height: 2;
}

/*导航图片*/
.nav-show-img {
  margin-top: 10px;
  float: left;
}

.nav-show-img:nth-child(2) {
  margin-left: 12px;
}

/*显示商品*/
.content {
  width: 100%;
}

/*显示商品详细信息*/

.detail-item-panel {
  width: 750px;
  height: 418px;
  background-color: #fff;
  position: absolute;
  top: 155px;
  left: 220px;
  z-index: 999;
  padding-right: 20px;
  border-radius: 0 10px 10px 0;
}

.item-thumb {
  width: 740px;
  height: 410px;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 15px;
}

/* 设置滚动条的样式 */
.item-thumb::-webkit-scrollbar {
  width: 5px;
}

/* 滚动槽 */
.item-thumb::-webkit-scrollbar-track {
  /* -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);*/
  border-radius: 10px;
  background-color: #f8f8f8;
}

/* 滚动条滑块 */
.item-thumb::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #FCAF4B;
  height: 10px;
  max-height: 20px !important;
  min-height: 11px !important;
  /*  background: -ms-radial-gradient(ellipse, #95D1E8, #f8f8f8);
    background: -webkit-radial-gradient(ellipse, #95D1E8, #f8f8f8);
    background: -moz-radial-gradient(ellipse, #95D1E8, #f8f8f8);
    background: radial-gradient(ellipse, #95D1E8, #f8f8f8);*/
}

.detail-item-panel::-webkit-scrollbar-thumb:window-inactive {
  height: 10px;
  max-height: 20px !important;
}

.nav-detail-item {
  margin-left: 26px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  color: #eee;
}

.nav-detail-item span {
  padding: 6px;
  padding-left: 12px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6e6568;
}

.nav-detail-item span:hover {
  margin-left: 15px;
  background-color: #629812;
}

.detail-item-panel ul {
  list-style: none;
}

.detail-item-panel li {
  line-height: 25px;
  margin-left: 30px;
}

.detail-item-title {
  border-left: 2px solid #629812;
  text-indent: 9px;
  margin-top: 12px;
  font-size: 14px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
}

.detail-item-title:hover {
  color: #629812;
}

.detail-item-row a {
  color: #555555;
}

.detail-item-row .detail-item:first-child {}

.detail-item-row a .detail-item {
  padding: 0 14px;
  cursor: pointer;
  font-size: 12px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #666;
  line-height: 17px;
}

.detail-item-row a .detail-item {
  border-left: 1px solid #efefef;
  text-align: center;

  &:hover {
    color: #629812 !important;
  }
}

.detail-item-row a:first-child .detail-item:first-child {
  display: inline-block;
  padding: 0 14px 0 0;
  border: none;
}

.three-classify {
  box-sizing: border-box;
  padding-top: 10px;
  border-top: 1px solid #efefef;
  margin-top: 10px;
}

.detail-item:hover {
  color: #629812;
}

.classList {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  .flex {
    width: 50%;
  }
}

.one-classify {
  font-size: 16px;
  font-family: PingFangHK-Medium, PingFangHK;
  font-weight: 500;
  color: #629812;
  line-height: 22px;
  padding: 26px 0 0 29px;
}

</style>



// WEBPACK FOOTER //
// src/components/Search.vue